import { SEARCH_TYPE_NAMES } from '@lt/components/constants/search';
import { WidgetName } from '../../models';

import type { WidgetSettingsConstructorParams } from './types';

import { environment } from '../../environments';
import { getWhitelabelDomain, getIsWhitelabel } from '../../utils';

export const MAX_SELECTED_DESTINATION = 18;

export const DEFAULT_DIRECTION_DESTINATIONS = [
  'Турция',
  'Египет',
  'Россия',
  'Абхазия',
  'ОАЭ',
  'Таиланд',
  'Мальдивы',
  'Шри-Ланка',
  'Индия',
  'Армения',
  'Сейшелы',
  'Узбекистан',
];

export const DEFAULT_SEARCH_DESTINATION = 'Турция';

export const DEFAULT_WIDGET_SETTINGS: WidgetSettingsConstructorParams = {
  selectedWidget: {
    label: 'Виджет',
    description: 'Выберите виджет',
    active: true,
    value: WidgetName.CIGARETTE,
    options: {
      'Виджет поисковой формы': WidgetName.CIGARETTE,
      'Виджет пакета': WidgetName.PACKAGE,
      'Виджет отеля': WidgetName.HOTEL,
      'Виджет направлений': WidgetName.DIRECTION,
      'Виджет поиска': WidgetName.SEARCH,
      'Виджет метарегионов': WidgetName.METAREGIONS,
    },
  },
  package_url: {
    label: 'URL пакета',
    description: 'Вставьте URL пакета, из которого хотите сформировать виджет',
    active: false,
    value: '',
  },
  hotel_url: {
    label: 'URL отеля',
    description: 'Вставьте URL отеля, из которого хотите сформировать виджет',
    active: false,
    value: '',
  },
  host: {
    label: 'Домен редиректа',
    description: 'Домен, на который будут перенаправлены пользователи',
    active: !!getWhitelabelDomain(),
    value: getWhitelabelDomain() || environment.defaultDomain,
    options: {
      ...(getWhitelabelDomain()
        ? {
            'partner domain': getWhitelabelDomain(),
          }
        : {}),
    },
  },
  isTabsSwitchOn: {
    label: 'Включить табы переключения типа поиска',
    description: 'Показывать табы туры/отели',
    active: true,
    value: true,
  },
  search_type: {
    label: 'Тип поиска по умолчанию',
    description: 'Выберите тип поиска: туры или только проживание',
    active: false,
    value: SEARCH_TYPE_NAMES.PACKAGE,
    options: {
      Туры: SEARCH_TYPE_NAMES.PACKAGE,
      'Только проживание': SEARCH_TYPE_NAMES.HOTEL,
    },
  },
  destination_ids: {
    active: false,
  },
  departure: {
    label: 'Город вылета',
    description: 'Выберите город вылета',
    active: false,
    value: {
      description: 'Определен автоматически',
      distance: 27,
      id: 213,
      isAutomaticallyDetected: true,
      iso2: 'RU',
      label: 'Москва',
      selectedLabel: 'Москвы',
      value: 'Moscow',
    },
  },
  apiConfig: {
    baseURL: 'https://api.level.travel',
    key: '',
  },
  start_date: {
    label: 'Дата вылета',
    description: '',
    active: false,
    value: 'TWO_WEEKS',
    options: {
      'Через неделю': 'WEEK',
      'Через 2 недели': 'TWO_WEEKS',
      'Через 3 недели': 'THREE_WEEKS',
      'Следующие выходные': 'NEXT_WEEKEND',
      '14 февраля': 'FEB_14',
      '23 февраля': 'FEB_23',
      '8 марта': 'MARCH_8',
      'Школьные весенние каникулы (28 марта)': 'MARCH_28',
      '1 мая': 'MAY_1',
      '9 мая': 'MAY_9',
      'Школьные осенние каникулы (28 октября)': 'OCT_28',
      'Ноябрьские праздники (4 ноября)': 'NOV_4',
      'Новый год': 'NEW_YEAR',
    },
  },
  nights: {
    label: 'Количество ночей',
    description: 'Введите количество ночей',
    active: false,
    value: '7..9',
    options: {
      'от 4 до 6': '4..6',
      'от 7 до 9': '7..9',
      'от 10 до 12': '10..12',
      'от 2 до 4': '2..4',
      'от 12 до 14': '12..14',
    },
  },
  adults: {
    label: 'Количество взрослых туристов',
    description: 'Введите количество взрослых туристов',
    active: false,
    value: 2,
  },
  kids: {
    label: 'Количество детей',
    description: 'Введите количество детей',
    active: false,
    value: [0],
  },
  redirect: {
    label: 'Вариант редиректа',
    description: 'Можно использовать значения атрибута target тега a',
    active: true,
    value: '_blank',
    options: {
      'В новом окне': '_blank',
      'В текущей вкладке': '_self',
    },
  },
  isBlankBackground: {
    label: 'Отключить подложку',
    description: 'Выберите, использовать ли подложку сигареты',
    active: false,
    value: false,
  },
  currency: {
    label: 'Валюта',
    description: 'Выберите валюту',
    active: true,
    value: 'rub',
    options: {
      rub: 'rub',
    },
  },
  lang: {
    label: 'Язык',
    description: 'Выберите язык',
    active: true,
    value: 'ru',
    options: {
      Русский: 'ru',
    },
  },
  utmParams: {
    label: 'Дополнительные параметры перехода',
    description: 'Любые валидные значения GET параметров',
    active: true,
    value: {},
  },
  isPassLtAflt: {
    label: 'Использовать метку LT',
    description: 'Прописывать при переходе aflt=LT',
    active: !getIsWhitelabel(),
    value: false,
  },
};

export const PACKAGE_WIDGET_SETTINGS: WidgetSettingsConstructorParams = {
  ...DEFAULT_WIDGET_SETTINGS,
  selectedWidget: {
    ...DEFAULT_WIDGET_SETTINGS.selectedWidget,
    value: WidgetName.PACKAGE,
  },
  package_url: {
    ...DEFAULT_WIDGET_SETTINGS.package_url,
    active: true,
  },
};

export const HOTEL_WIDGET_SETTINGS: WidgetSettingsConstructorParams = {
  ...DEFAULT_WIDGET_SETTINGS,
  selectedWidget: {
    ...DEFAULT_WIDGET_SETTINGS.selectedWidget,
    value: WidgetName.HOTEL,
  },
  hotel_url: {
    ...DEFAULT_WIDGET_SETTINGS.hotel_url,
    active: true,
  },
  search_type: {
    ...DEFAULT_WIDGET_SETTINGS.search_type,
    active: true,
  },
  departure: {
    ...DEFAULT_WIDGET_SETTINGS.departure,
    active: true,
  },
  start_date: {
    ...DEFAULT_WIDGET_SETTINGS.start_date,
    active: true,
  },
  nights: {
    ...DEFAULT_WIDGET_SETTINGS.nights,
    active: true,
  },
  adults: {
    ...DEFAULT_WIDGET_SETTINGS.adults,
    active: true,
  },
  kids: {
    ...DEFAULT_WIDGET_SETTINGS.kids,
    value: 0,
    active: true,
  },
};

export const CIGARETTE_WIDGET_SETTINGS: WidgetSettingsConstructorParams = {
  ...DEFAULT_WIDGET_SETTINGS,
  isTabsSwitchOn: {
    ...DEFAULT_WIDGET_SETTINGS.isTabsSwitchOn,
    active: true,
  },
  selectedWidget: {
    ...DEFAULT_WIDGET_SETTINGS.selectedWidget,
    value: WidgetName.CIGARETTE,
  },
  search_type: {
    ...DEFAULT_WIDGET_SETTINGS.search_type,
    active: true,
  },
  isBlankBackground: {
    ...DEFAULT_WIDGET_SETTINGS.isBlankBackground,
    active: true,
  },
  departure: {
    ...DEFAULT_WIDGET_SETTINGS.departure,
    active: true,
  },
  utmParams: {
    ...DEFAULT_WIDGET_SETTINGS.utmParams,
    active: true,
  },
  redirect: {
    ...DEFAULT_WIDGET_SETTINGS.redirect,
    active: true,
  },
};

export const DIRECTION_WIDGET_SETTINGS: WidgetSettingsConstructorParams = {
  ...DEFAULT_WIDGET_SETTINGS,
  selectedWidget: {
    ...DEFAULT_WIDGET_SETTINGS.selectedWidget,
    value: WidgetName.DIRECTION,
  },
  destination_ids: { ...DEFAULT_WIDGET_SETTINGS.destination_ids, active: true },
  departure: { ...DEFAULT_WIDGET_SETTINGS.departure, active: true },
  adults: { ...DEFAULT_WIDGET_SETTINGS.adults, active: true },
  kids: {
    ...DEFAULT_WIDGET_SETTINGS.kids,
    value: 0,
    active: true,
  },
  start_date: { ...DEFAULT_WIDGET_SETTINGS.start_date, active: true },
  nights: { ...DEFAULT_WIDGET_SETTINGS.nights, active: true },
};

export const SEARCH_WIDGET_SETTINGS: WidgetSettingsConstructorParams = {
  ...DIRECTION_WIDGET_SETTINGS,
  selectedWidget: {
    ...DEFAULT_WIDGET_SETTINGS.selectedWidget,
    value: WidgetName.SEARCH,
  },
  search_type: {
    ...DEFAULT_WIDGET_SETTINGS.search_type,
    active: true,
  },
};

export const METAREGIONS_WIDGET_SETTINGS: WidgetSettingsConstructorParams = {
  ...DIRECTION_WIDGET_SETTINGS,
  selectedWidget: {
    ...DEFAULT_WIDGET_SETTINGS.selectedWidget,
    value: WidgetName.METAREGIONS,
  },
};
